module.exports = __webpack_public_path__ + "static/images/2948926d302fef6ad3d797ee0262dcf9.svg";